import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.picker = flatpickr(this.inputTarget, {
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "m/d/Y",
      allowInput: true,
      disableMobile: true,
      onChange: (_selectedDates, _dateStr, _instance) => {
        this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    // Live-format typed digits into MM/DD/YYYY (e.g. "12141981" -> "12/14/1981").
    if (this.picker.altInput) {
      this.picker.altInput.addEventListener("input", this.maskDate);
    }
  }

  // Insert slashes as the user types digits; leave deletions alone so backspace
  // works naturally.
  maskDate = (event) => {
    if (event.inputType && event.inputType.startsWith("delete")) return;

    const el = event.target;
    const digits = el.value.replace(/\D/g, "").slice(0, 8);
    let formatted = digits;
    if (digits.length > 4) {
      formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    } else if (digits.length > 2) {
      formatted = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    }
    el.value = formatted;
  };

  toggle() {
    this.picker.toggle();
  }

  disconnect() {
    if (this.picker) {
      if (this.picker.altInput) {
        this.picker.altInput.removeEventListener("input", this.maskDate);
      }
      this.picker.destroy();
    }
  }
}
